import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import Button from "../../Button";

/**
 * Shown when the session gate blocks advancement: the chapter the student
 * just finished has a session below the pass threshold (or an assessment
 * they failed). A retry replays the same chapter — new attempt rows are
 * appended server-side and latest-attempt scoring makes the retake
 * authoritative.
 */
const SessionRetake = ({ session, chapterName, onRetry }) => {
    const isAssessment = session?.sessionType === "ASSESSMENT";
    const name =
        (isAssessment && session?.assessmentName) ||
        chapterName ||
        session?.chapterName ||
        "this session";
    const score = session?.score;
    const threshold = session?.threshold ?? 60;
    const nextAttempt = (session?.attempts || 0) + 1;

    return (
        <Box sx={styles.container}>
            <Typography sx={styles.title}>
                Almost there — let's try that again!
            </Typography>

            <Typography sx={styles.subtitle}>
                {score != null
                    ? <>You scored <b>{Math.round(score)}%</b> on <b>{name}</b> — you need <b>{Math.round(threshold)}%</b> to continue.</>
                    : <>You need to complete <b>{name}</b> with a score of at least <b>{Math.round(threshold)}%</b> to continue.</>}
            </Typography>

            <Chip
                label={`Attempt ${nextAttempt}`}
                size="small"
                sx={styles.attemptChip}
            />

            <Button
                icon={<ReplayIcon />}
                onClick={onRetry}
                variant="contained"
                size="lg"
                placeholder={isAssessment ? "Retake assessment" : "Retake session"}
                sx={{
                    minWidth: "180px",
                    background: "var(--mui-palette-primary-button)",
                    p: 1,
                    mt: 3,
                }}
            />
        </Box>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        px: 3,
    },
    title: {
        fontSize: "1.6em",
        fontWeight: 700,
        color: "var(--mui-palette-text-primary)",
        mb: 1,
    },
    subtitle: {
        fontSize: "1em",
        color: "var(--mui-palette-text-primary)",
        mb: 2,
        maxWidth: "480px",
    },
    attemptChip: {
        background: "#CFEBFE",
        fontWeight: 600,
    },
};

export default SessionRetake;
